import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';
import styles from './PaymentSuccessPage.module.css';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function PaymentSuccessPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const confirm = async () => {
            const paymentKey = searchParams.get('paymentKey');
            const orderId = searchParams.get('orderId');
            const amount = searchParams.get('amount');
            const addressId = searchParams.get('addressId');

            try {
                const response = await axios.post(`${API_URL}/api/payments/confirm`, {
                    paymentKey,
                    orderId,
                    amount: parseInt(amount),
                    addressId: parseInt(addressId)
                }, authHeader());

                setOrder(response.data);
            } catch (err) {
                setError(true);
            } finally {
                setLoading(false);
            }
        };
        confirm();
    }, []);

    if (loading) return (
        <div className={styles.loadingContainer}>
            <div className={styles.spinner} />
            <p>결제 처리 중입니다...</p>
        </div>
    );

    if (error) return (
        <div className={styles.container}>
            <div className={styles.errorBox}>
                <p className={styles.errorIcon}>✕</p>
                <h2>결제 검증에 실패했습니다.</h2>
                <p className={styles.errorDesc}>다시 시도해 주시거나 고객센터로 문의해 주십시오.</p>
                <button className={styles.btnPrimary} onClick={() => navigate('/cart')}>장바구니로 돌아가기</button>
            </div>
        </div>
    );

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <div className={styles.successIcon}>✓</div>
                <h2 className={styles.title}>주문이 완료되었습니다</h2>
                <p className={styles.subtitle}>주문번호 #{order?.orderId}</p>

                <div className={styles.infoSection}>
                    <h4 className={styles.sectionTitle}>주문 상품</h4>
                    {order?.orderItems?.map((item, i) => (
                        <div key={i} className={styles.orderItem}>
                            <img src={`${API_URL}${item.imageUrl}`}
                                alt={item.productName} className={styles.itemImage} />
                            <div className={styles.itemInfo}>
                                <p className={styles.itemName}>{item.productName}</p>
                                <p className={styles.itemDetail}>{item.quantity}개 · {item.price?.toLocaleString()}원</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={styles.infoSection}>
                    <h4 className={styles.sectionTitle}>배송지</h4>
                    <p className={styles.addressText}>
                        {order?.address?.recipient} · {order?.address?.phone}
                    </p>
                    <p className={styles.addressText}>
                        [{order?.address?.zipcode}] {order?.address?.address1} {order?.address?.address2}
                    </p>
                </div>

                <div className={styles.infoSection}>
                    <h4 className={styles.sectionTitle}>결제 금액</h4>
                    <div className={styles.priceRow}>
                        <span>상품 금액</span>
                        <span>{(order?.totalPrice - (order?.deliveryFee || 0))?.toLocaleString()}원</span>
                    </div>
                    <div className={styles.priceRow}>
                        <span>배송비</span>
                        <span>{order?.deliveryFee > 0 ? `${order?.deliveryFee?.toLocaleString()}원` : '무료'}</span>
                    </div>
                    <div className={`${styles.priceRow} ${styles.totalRow}`}>
                        <span>총 결제금액</span>
                        <span>{order?.totalPrice?.toLocaleString()}원</span>
                    </div>
                </div>

                <div className={styles.buttonGroup}>
                    <button className={styles.btnPrimary}
                        onClick={() => navigate(`/orders/${order?.orderId}`)}>
                        주문 상세 보기
                    </button>
                    <button className={styles.btnOutline}
                        onClick={() => navigate('/products')}>
                        쇼핑 계속하기
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PaymentSuccessPage;